import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../../assets/imgs/earth.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c19a0ac2"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "no-net-container"
};
var _hoisted_2 = {
  class: "no-net-content"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "no-net-img",
    src: _imports_0
  }, null, -1);
});

var _hoisted_4 = {
  class: "no-net-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('message.noNet')), 1)])]);
}